"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = onEnterPressed;

function onEnterPressed(a) {
  var b = a.onClick;
  return b ? function (a) {
    (13 === a.which || 13 === a.keyCode) && (a.preventDefault(), a.stopPropagation(), b(a));
  } : null;
}